import React from 'react';
import PropTypes from 'prop-types';
import { getTypeInfo } from 'credit-card-type';

import { normalizePaymentType } from 'helpers/MyAccountUtils';
import css from 'styles/components/account/orderInformation.scss';

const makeShippingAddress = (address, testId) => {
  if (address) {
    const { fullName, addressLine1, addressLine2, city, stateOrRegion, postalCode, countryName } = address;
    return (
      <div>
        <h2>Shipping Address</h2>
        <div data-test-id={testId('shippingName')}>{fullName}</div>
        <div data-test-id={testId('shippingLine1')}>{addressLine1}</div>
        <div data-test-id={testId('shippingLine2')}>{addressLine2}</div>
        <div data-test-id={testId('shippingCityState')}>{city}, {stateOrRegion}, {postalCode}</div>
        <div data-test-id={testId('shippingCountry')}>{countryName}</div>
      </div>
    );
  } else {
    return <div data-test-id={testId('electronicDelivery')}>This order was delivered electronically.</div>;
  }
};

const makeBillingAddress = (billingAddress, testId) => {
  const { fullName, addressLine1, addressLine2, city, stateOrRegion, postalCode, countryName } = billingAddress;
  if (billingAddress) {
    return (
      <div>
        <div data-test-id={testId('billingName')}>{fullName}</div>
        <div data-test-id={testId('billingLine1')}>{addressLine1}</div>
        <div data-test-id={testId('billingLine2')}>{addressLine2}</div>
        <div data-test-id={testId('billingCityState')}>{city}, {stateOrRegion}, {postalCode}</div>
        <div data-test-id={testId('billingCountry')}>{countryName}</div>
      </div>
    );
  }
};

const makePayment = (payment, billingAddress, testId) => {
  if (payment) {
    const { paymentType, addCreditCardNumber, expirationMonth, expirationYear } = payment;
    const cardType = getTypeInfo(normalizePaymentType(paymentType))?.niceType;
    return (
      <div>
        <h2>Payment Information</h2>
        <div data-test-id={testId('paymentCardInfo')}>{cardType} ending in {addCreditCardNumber}</div>
        <div data-test-id={testId('paymentCardExp')}>Exp. {expirationMonth}-{expirationYear}</div>
        {makeBillingAddress(billingAddress, testId)}
      </div>
    );
  }
};

const OrderInformation = ({ order, address, payment, paymentUpdated }, { testId }) => {
  const { billingAddress, orderId, orderDate, legacy } = order;
  return (
    <div className={css.orderInformation}>
      {paymentUpdated && <p className={css.paymentUpdateSuccess}><strong>Success!</strong> Your card has been updated. We're processing your order now.</p>}
      <div>
        <div className={css.orderNumber}>
          <h2>Order Number</h2>
          <div data-test-id={testId('orderId')}>{orderId}</div>
        </div>
        <div>
          <h2>Order Date</h2>
          <div data-test-id={testId('orderDate')}>{orderDate}</div>
        </div>
      </div>
      {!legacy && makeShippingAddress(address, testId)}
      {makePayment(payment, billingAddress, testId)}
    </div>
  );
};

OrderInformation.contextTypes = {
  testId: PropTypes.func
};

OrderInformation.propTypes = {
  order: PropTypes.object.isRequired,
  address: PropTypes.object,
  payment: PropTypes.object
};

export default OrderInformation;
